<template>
  <div style="overflow-y: hidden">
    <div class="report_query_box">
      <!--      <div class="item_box">-->
      <!--        <span>所属单位：</span>-->
      <!--        <a-tree-select-->
      <!--            v-model="search.deptId"-->
      <!--            allow-clear-->
      <!--            :dropdown-style="{ maxHeight: '300px', overflow: 'auto' }"-->
      <!--            :treeData="treeDeptData"-->
      <!--            :replaceFields="{children:'children', title:'text', key:'id', value: 'id' }"-->
      <!--            style="width: 150px;"-->
      <!--        >-->
      <!--        </a-tree-select>-->
      <!--      </div>-->

      <div class="item_box" v-if="searchDateRangeShow">
        <span>日期：</span>
        <a-range-picker
            @change="onChangeDate"
            :default-value="dateDefaultDate"
            :format="dateFormat"
            style="width: 350px;"
        />
      </div>

      <div class="item_box">
        <span>品系：</span>
        <a-select
            v-model="search.activityStrain"
            :options="strainOptions"
            style="width: 150px;"
        >
        </a-select>
      </div>

      <div class="item_box">
        <span>经销商：</span>
        <a-select
            v-model="search.regionId"
            :options="regionOptions"
            style="width: 150px;"
        >
        </a-select>
      </div>

      <div class="item_box">
        <span>经理部：</span>
        <a-select
            v-model="search.dealerId"
            :options="dealerOptions"
            style="width: 150px;"
        >
        </a-select>
      </div>
<!--      <div class="item_box">-->
<!--        <span>类型</span>-->
<!--        <a-select-->
<!--            v-model="search.activityType"-->
<!--            :options="activityTypeOptions"-->
<!--            style="width: 150px;"-->
<!--        >-->
<!--        </a-select>-->
<!--      </div>-->

<!--      <div class="item_box">-->
<!--        <span>类别</span>-->
<!--        <a-select-->
<!--            v-model="search.activityCategory"-->
<!--            :options="activityCategoryOptions"-->
<!--            style="width: 150px;"-->
<!--        >-->
<!--        </a-select>-->
<!--      </div>-->

      <!--      <div class="item_box">-->
      <!--        <span>销售顾问：</span>-->
      <!--        <a-input v-model="search.userName" style="width: 150px;" @keyup.enter.native="searchData"/>-->
      <!--      </div>-->

      <a-button class="func_btn_item" type="primary" @click="searchData">筛选</a-button>
      <a-button class="func_btn_item" @click="resetData">重置</a-button>
      <a-button class="func_btn_item" type="primary" @click="exportData">导出</a-button>
    </div>
    <a-table
        :columns="columns"
        :data-source="tableData"
        :pagination="pagination"
        bordered
        :loading="loading"
        size="middle"
        :scroll="{ x: 'calc(700px + 50%)', y: 600 }"
    />
  </div>
</template>
<script>
import {formatter as fmt} from "@/utils/ebase-formatter";
import {dataApi} from "@/services/report/report.js";
import api from "@/services/api";
import {loadBaseCodeData} from "@/services/baseCodeSource";
import XEUtils from "xe-utils";
import moment from 'moment';

console.log(fmt, loadBaseCodeData)

// 多表头 固定表头
const columns = [
  {
    title: '品系名称',
    dataIndex: 'strainName',
    key: 'strainName',
    width: 100,
    align: 'center',
    fixed: 'left',
    className:'bg-color',
  },
  {
    title: '经理部',
    dataIndex: 'regionName',
    key: 'regionName',
    width: 100,
    align: 'center',
    className:'bg-color',
  },
  {
    title: '经销商',
    dataIndex: 'dealerName',
    key: 'dealerName',
    width: 100,
    align: 'center',
    className:'bg-color',
  },
  // {
  //   title: '销售顾问',
  //   dataIndex: 'userName',
  //   key: 'userName',
  //   width: 100,
  //   align: 'center',
  // },
  // {
  //   title: '二网拜访',
  //   children: [
  //     {
  //       title: '新增',
  //       children: [
  //         {
  //           title: '计划',
  //           dataIndex: 'addPlanCustNum',
  //           key: 'addPlanCustNum',
  //           width: 80,
  //           align: 'center',
  //         },
  //         {
  //           title: '实绩',
  //           dataIndex: 'addCustNum',
  //           key: 'addCustNum',
  //           width: 80,
  //           align: 'center',
  //         },
  //         {
  //           title: '完成率',
  //           dataIndex: 'custPercent',
  //           key: 'custPercent',
  //           width: 80,
  //           align: 'center',
  //         },
  //       ],
  //     },
  //     {
  //       title: '累计',
  //       dataIndex: 'totalCustNum',
  //       key: 'totalCustNum',
  //       width: 100,
  //       align: 'center',
  //     },
  //   ],
  // },
  // {
  //   title: '大客户拜访',
  //   children: [
  //     {
  //       title: '新增',
  //       children: [
  //         {
  //           title: '目标',
  //           dataIndex: 'addPlanClueNum',
  //           key: 'addPlanClueNum',
  //           width: 80,
  //           align: 'center',
  //         },
  //         {
  //           title: '实绩',
  //           dataIndex: 'addClueNum',
  //           key: 'addClueNum',
  //           width: 80,
  //           align: 'center',
  //         },
  //         {
  //           title: '完成率',
  //           dataIndex: 'cluePercent',
  //           key: 'cluePercent',
  //           width: 80,
  //           align: 'center',
  //         },
  //       ],
  //     },
  //     {
  //       title: '累计',
  //       children: [
  //         {
  //           title: 'B级',
  //           dataIndex: 'totalClueNumB',
  //           key: 'totalClueNumB',
  //           width: 80,
  //           align: 'center',
  //         },
  //         {
  //           title: 'A级',
  //           dataIndex: 'totalClueNumA',
  //           key: 'totalClueNumA',
  //           width: 80,
  //           align: 'center',
  //         },
  //         {
  //           title: 'H级',
  //           dataIndex: 'totalClueNumH',
  //           key: 'totalClueNumH',
  //           width: 80,
  //           align: 'center',
  //         },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   title: '常规活动',
  //   children: [
  //     {
  //       title: '新增',
  //       children: [
  //         {
  //           title: 'B级',
  //           dataIndex: 'addWantCountB',
  //           key: 'addWantCountB',
  //           width: 80,
  //           align: 'center',
  //         },
  //         {
  //           title: 'A级',
  //           dataIndex: 'addWantCountA',
  //           key: 'addWantCountA',
  //           width: 80,
  //           align: 'center',
  //         },
  //         {
  //           title: 'H级',
  //           dataIndex: 'addWantCountH',
  //           key: 'addWantCountH',
  //           width: 80,
  //           align: 'center',
  //         },
  //       ],
  //     },
  //     {
  //       title: '累计',
  //       children: [
  //         {
  //           title: 'B级',
  //           dataIndex: 'totalWantCountB',
  //           key: 'totalWantCountB',
  //           width: 80,
  //           align: 'center',
  //         },
  //         {
  //           title: 'A级',
  //           dataIndex: 'totalWantCountA',
  //           key: 'totalWantCountA',
  //           width: 80,
  //           align: 'center',
  //         },
  //         {
  //           title: 'H级',
  //           dataIndex: 'totalWantCountH',
  //           key: 'totalWantCountH',
  //           width: 80,
  //           align: 'center',
  //         },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   title: '专项活动',
  //   children: [
  //     {
  //       title: '新客户',
  //       dataIndex: 'newCustCount',
  //       key: 'newCustCount',
  //       width: 80,
  //       align: 'center',
  //     },
  //     {
  //       title: '老客户',
  //       dataIndex: 'oldCustCount',
  //       key: 'oldCustCount',
  //       width: 80,
  //       align: 'center',
  //     },
  //   ]
  // },
  {
    title: '二网拜访',
    children: [
      {
        title: '计划',
        dataIndex: '',
        key: '',
        width: 80,
        align: 'center',
      },
      {
        title: '实绩',
        dataIndex: '',
        key: '',
        width: 80,
        align: 'center',
      },
      {
        title: '完成率',
        dataIndex: '',
        key: '',
        width: 80,
        align: 'center',
      },
    ]
  },
  {
    title: '大客户拜访',
    children: [
      {
        title: '计划',
        dataIndex: '',
        key: '',
        width: 80,
        align: 'center',
      },
      {
        title: '实绩',
        dataIndex: '',
        key: '',
        width: 80,
        align: 'center',
      },
      {
        title: '完成率',
        dataIndex: '',
        key: '',
        width: 80,
        align: 'center',
      },
    ]
  },
  {
    title: '常规活动',
    children: [
      {
        title: '计划',
        dataIndex: '',
        key: '',
        width: 80,
        align: 'center',
      },
      {
        title: '实绩',
        dataIndex: '',
        key: '',
        width: 80,
        align: 'center',
      },
      {
        title: '完成率',
        dataIndex: '',
        key: '',
        width: 80,
        align: 'center',
      },
    ]
  },
  {
    title: '预留一',
    children: [
      {
        title: '计划',
        dataIndex: '',
        key: '',
        width: 80,
        align: 'center',
      },
      {
        title: '实绩',
        dataIndex: '',
        key: '',
        width: 80,
        align: 'center',
      },
      {
        title: '完成率',
        dataIndex: '',
        key: '',
        width: 80,
        align: 'center',
      },
    ]
  },
  {
    title: '预留二',
    children: [
      {
        title: '计划',
        dataIndex: '',
        key: '',
        width: 80,
        align: 'center',
      },
      {
        title: '实绩',
        dataIndex: '',
        key: '',
        width: 80,
        align: 'center',
      },
      {
        title: '完成率',
        dataIndex: '',
        key: '',
        width: 80,
        align: 'center',
      },
    ]
  },
  {
    title: '预留三',
    children: [
      {
        title: '计划',
        dataIndex: '',
        key: '',
        width: 80,
        align: 'center',
      },
      {
        title: '实绩',
        dataIndex: '',
        key: '',
        width: 80,
        align: 'center',
      },
      {
        title: '完成率',
        dataIndex: '',
        key: '',
        width: 80,
        align: 'center',
      },
    ]
  }

];

export default {
  data() {
    return {
      searchDateRangeShow: true,
      dateDefaultDate: [],
      dateFormat: 'YYYY-MM-DD',
      loading: false,
      tableData: [],
      columns,
      // treeDeptData: [],
      regionOptions: [],//经理部
      dealerOptions: [],//经销商
      strainOptions: [],//品系
      //userOptions: [],//销售顾问
      //新增
      activityCategoryOptions:[],//类别
      activityTypeOptions:[],//类型
      search: {
        page: 1,
        limit: 10,
        startTime: '',
        endTime: '',
        // deptId: 0,
        dealerId: '',// 经销商id
        regionId: '',// 经理部id
        activityStrain: '',// 品系id
        //userId: '',// 销售顾问id
        //userName: '',//销售顾问名称搜索
        activityType:'',//类型id
        activityCategory:'',//类别id
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        onChange: (page, pageSize) => { //切换页page
          console.log(page);
          console.log(pageSize);
          this.getTableData(page, pageSize);
        },
        showSizeChanger: true,
        onShowSizeChange: (current, size) => { //切换pageSize
          console.log('当前页码', current)
          console.log(size)
          this.getTableData(1, size);
        },
      }
    };
  },
  created() {
    this.handleDefaultDateRange();
  },
  async mounted() {
    this.loadSearchBaseData();
    this.getTableData();
  },
  methods: {
    moment,
    handleDefaultDateRange() {
      //日期默认月初 - 到当天
      this.dateDefaultDate = [];
      this.search.startTime = XEUtils.toDateString(new Date(new Date().getFullYear(), new Date().getMonth(), 1), 'yyyy-MM-dd')
      this.search.endTime = XEUtils.toDateString(new Date(), 'yyyy-MM-dd')
      this.dateDefaultDate.push(moment(this.search.startTime))
      this.dateDefaultDate.push(moment(this.search.endTime))
    },
    /**
     * 获取多表头表格数据
     * @param currentPage 当前页码 默认1
     * @param pageSize pageSize 默认10
     */
    getTableData(currentPage, pageSize) {
      this.search.page = currentPage ? currentPage : 1;
      this.search.limit = pageSize ? pageSize : 10;
      this.loading = true;
      dataApi.activityReportData({...this.search}).then(res => {
        console.log('tableData', res)
        this.loading = false;

        let resData = res.data;
        if (!resData.list.length) {
          console.log('暂无数据');
          this.tableData = [];
          this.pagination.total = 0;
          return false;
        }

        if (currentPage) {
          this.pagination.current = currentPage;
        }
        this.pagination.total = resData.totalCount;
        this.pagination.pageSize = resData.pageSize;

        this.tableData = [];
        resData.list.forEach((item, index) => {
          this.tableData.push({
            key: index,

            "activityNo": item.activityNo,//品系
            "deptName": item.deptName,//经理部
            "dealerDeptName": item.dealerDeptName,//经销商
            // "": item.,//二网拜访-计划
            // "": item.,//二网拜访-实绩
            // "": item.,//二网拜访-完成率
            // "": item.,//大客户拜访-计划
            // "": item.,//大客户拜访-实绩
            // "": item.,//大客户拜访-完成率
            // "": item.,//常规活动-计划
            // "": item.,//常规活动-实绩
            // "": item.,//常规活动-完成率
            // "": item.,//专项活动-计划
            // "": item.,//专项活动-实绩
            // "": item.,//专项活动-完成率
            // "": item.,//预留一-计划
            // "": item.,//预留一-实绩
            // "": item.,//预留一-完成率
            // "": item.,//预留二-计划
            // "": item.,//预留二-实绩
            // "": item.,//预留二-完成率


            "dealerId": item.dealerId,  //   经销商id
            "regionId": item.regionId, //   经理部id
            "strainId": item.strainId, //   品系id
            "activityType": item.activityType,//类型id
            "activityCategory": item.activityCategory,//类别id

            // "addPlanCustNum": item.addPlanCustNum, //    客户数-新增-目标
            // "addCustNum": item.addCustNum,  //    客户数-新增-实绩
            // "custPercent": item.custPercent,  //    客户数-新增-完成率
            // "totalCustNum": item.totalCustNum,   //      客户数-累计
            //
            // "addPlanClueNum": item.addPlanClueNum, //    线索数-新增-目标
            // "addClueNum": item.addClueNum,   //   线索数-新增-实绩
            // "cluePercent": item.cluePercent,   //   线索完成率
            // "totalClueNumH": item.totalClueNumH,  //    线索数-累计-H
            // "totalClueNumA": item.totalClueNumA,   //   线索数-累计-A
            // "totalClueNumB": item.totalClueNumB,   //   线索数-累计-B
            //
            // "addWantCountH": item.addWantCountH,  //    意向台数-新增-H
            // "addWantCountB": item.addWantCountB,  //    意向台数-新增-B
            // "addWantCountA": item.addWantCountA,  //   意向台数-新增-A
            // "totalWantCountH": item.totalWantCountH, //    意向台数-累计-H
            // "totalWantCountB": item.totalWantCountB,  //   意向台数-累计-B
            // "totalWantCountA": item.totalWantCountA, //    意向台数-累计-A
            //
            // "newCustCount": item.newCustCount,   //   成交客户-新客户数
            // "oldCustCount": item.oldCustCount,   //   成交客户-老客户数
            //
            // "newCustWantCount": item.newCustWantCount,  //   成交台数-新客户
            // "oldCustWantCount": item.oldCustWantCount,  //   成交台数-老客户
            //
            //"dealerId": item.dealerId,  //   经销商id
            // "deptId": item.deptId, //   销售顾问部门id
            // "userId": item.userId, //   销售顾问id
            //"regionId": item.regionId, //   经理部id
            //"strainId": item.strainId, //   品系id

          })
        })
      });
    },
    //重置
    resetData() {
      this.handleDefaultDateRange();
      //处理更新日期组件不更新问题
      this.searchDateRangeShow = false;
      this.$nextTick(()=>{
        this.searchDateRangeShow = true;
      })
      this.search.dealerId = '';
      this.search.deptId = '';
      this.search.regionId = '';
      // this.search.strainId = '';
      // this.search.userName = '';
      this.search.activityStrain = '';
      this.search.activityType = '';
      this.search.activityCategory = '';

      this.search = {
        ...this.search,
        'filter.eq.dealerId': '',
        'filter.eq.deptId': '',
        // 'filter.like.userName': '',
        'filter.eq.regionId': '',
        'filter.eq.activityStrain': '',
        'filter.eq.activityType': '',
        'filter.eq.activityCategory': '',
      }
      this.getTableData()
    },
    // 搜索
    async searchData() {
      this.search = {
        ...this.search,
        'filter.eq.dealerId': this.search.dealerId,
        'filter.eq.deptId': this.search.deptId,
        // 'filter.like.userName': this.search.userName,
        'filter.eq.regionId': this.search.regionId,
        'filter.eq.activityStrain': this.search.strainId,
        'filter.eq.activityType': this.search.activityType,
        'filter.eq.activityCategory': this.search.activityCategory,
      }
      this.getTableData()
    },
    //todo 导出
    async exportData() {
      if (!this.tableData || this.tableData.length <= 0) {
        this.$message.error('当前没有数据可导出')
        return false
      }
      const params = {...this.search}
      params.deptId === '' ? params.deptId = 0 : ''
      params.custLevelId === '' ? params.custLevelId = 0 : ''
      params.columns = this.columns;
      // 开始服务端导出
      await dataApi.exportFile(api.report.CUSTOMER_REPORT + "/saleCallonAnalyse/export", params).then(blob => {
        this.$message.success('导出成功，开始下载');
        let downloadElement = document.createElement("a");
        let href = window.URL.createObjectURL(blob.data); //创建下载的链接
        downloadElement.href = href;
        downloadElement.download = '拜访分析' + '.xlsx'; //下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); //点击下载
        document.body.removeChild(downloadElement); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放掉blob对象
      }).catch(e => {
        console.error('导出失败:' + e);
        this.$message.error('导出失败');
      })
    },
    // 选择日期区间
    onChangeDate(data, dataString) {
      this.search.startTime = dataString[0]
      this.search.endTime = dataString[1]
    },
    // 加载搜索下拉 树等数据
    async loadSearchBaseData() {
      //经理部
      let region = {
        isRegion: 1,
        isDealer: 0
      }
      this.regionOptions = await dataApi.selection(region);//经理部
      // 经理部下拉处理
      this.regionOptions = this.regionOptions.data.map(v => {
        return {
          label: v.deptName,
          value: v.deptId
        }
      })
      this.regionOptions = [{
        value: '',
        label: '全部'
      }].concat(this.regionOptions);

      //经销商
      let dealer = {
        isRegion: 0,
        isDealer: 1
      }
      this.dealerOptions = await dataApi.selection(dealer);//经销商
      // 经销商下拉处理
      this.dealerOptions = this.dealerOptions.data.map(v => {
        return {
          label: v.deptName,
          value: v.deptId
        }
      })
      this.dealerOptions = [{
        value: '',
        label: '全部'
      }].concat(this.dealerOptions);

      //品系
      this.strainOptions = await dataApi.selectionStrain();//品系
      this.strainOptions = this.strainOptions.data.map(v => {
        return {
          label: v.strainName,
          value: v.strainId
        }
      })
      this.strainOptions = [{
        value: '',
        label: '全部'
      }].concat(this.strainOptions);

      //类型
      this.activityTypeOptions = await dataApi.selectionActivityType()
      this.activityTypeOptions = this.activityTypeOptions.data.map(v => {
        return {
          label: v.typeName,
          value: v.typeId
        }
      })
      this.activityTypeOptions = [{
        value: '',
        label: '全部'
      }].concat(this.activityTypeOptions);

      //销售顾问
      // this.userOptions = await loadBaseCodeData('CD200002')
      // this.userOptions = this.userOptions.map(v => {
      //   return {
      //     label: v.label,
      //     value: v.label
      //   }
      // })
      // this.userOptions = [{
      //   value: '',
      //   label: '全部'
      // }].concat(this.userOptions);

      //类别
      this.activityCategoryOptions = await loadBaseCodeData('CD400003')
      this.activityCategoryOptions = this.activityCategoryOptions.map(v => {
        return {
          label: v.codeName,
          value: v.codeId
        }
      })
      this.activityCategoryOptions = [{
        value: '',
        label: '全部'
      }].concat(this.activityCategoryOptions);

    }
  }
};
</script>

<style scoped lang="less">
.report_query_box {
  padding: 30px 12px;
  display: flex;
  flex-wrap: wrap;

  .item_box {
    margin-right: 20px;
    margin-bottom: 12px;
  }

  .func_btn_item {
    margin-left: 12px;
  }
}

</style>
